var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShareOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 3.12492C11.5625 2.77974 11.8424 2.49995 12.1876 2.5L16.8745 2.50062C17.2196 2.50067 17.4993 2.78043 17.4994 3.12554L17.5 7.81242C17.5 8.15759 17.2203 8.43745 16.8751 8.4375C16.5299 8.43755 16.25 8.15776 16.25 7.81258L16.2496 4.63431L11.6897 9.19419C11.4456 9.43827 11.0499 9.43827 10.8058 9.19419C10.5617 8.95011 10.5617 8.55439 10.8058 8.31031L15.3657 3.75042L12.1874 3.75C11.8422 3.74995 11.5625 3.47009 11.5625 3.12492Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5C3.41848 5 3.10054 5.1317 2.86612 5.36612C2.6317 5.60054 2.5 5.91848 2.5 6.25V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H13.75C14.0815 17.5 14.3995 17.3683 14.6339 17.1339C14.8683 16.8995 15 16.5815 15 16.25V11.25C15 10.9048 14.7202 10.625 14.375 10.625C14.0298 10.625 13.75 10.9048 13.75 11.25V16.25H3.75L3.75 6.25H8.75C9.09518 6.25 9.375 5.97018 9.375 5.625C9.375 5.27982 9.09518 5 8.75 5H3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareOut);
export default __webpack_public_path__ + "static/media/ic_share_out.d6a61d58.svg";
export { ForwardRef as ReactComponent };